// src/Pages/Landing/JoyridePirkanmaaLanding.jsx
import React from "react";
import JoyrideMaakuntaLanding from "./JoyrideMaakuntaLanding.jsx";
import joyrideHero from "../../assets/Joyride_04.webp";

export default function JoyridePirkanmaaLanding() {
  return (
    <JoyrideMaakuntaLanding
      maakunta="Pirkanmaa"
      cities={[
        "Tampere",
        "Nokia",
        "Ylöjärvi",
        "Pirkkala",
        "Lempäälä",
        "Kangasala",
        "Valkeakoski"
      ]}
      regionText="Bilebändi Joyride tekee keikkoja myös Pirkanmaan alueelle tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Tampereen seutu on hyvä esimerkki alueesta, jossa Bilebändi Joyride sopii erityisesti häihin, yritysjuhliin, kesäjuhliin ja pikkujouluihin."
      bookingLink="/#varaa"
      heroImage={joyrideHero}
    />
  );
}